export const Variant = {
  RECTANGULAR: 'rectangular',
  CIRCULAR: 'rounded',
  TEXT: 'text',
  DEFAULT: 'text',
}

export const Animation ={
  PULSE:'pulse',
  WAVE:'wave',
  STATIC: 'false',
};